function wranglerAttributeToProductOptionModel(data, uiLabels, allOptionsRequired) {
    return [
        ...data.attributes.map((attr) => ({
            key: attr.key,
            name: attr.name,
            style: 'buttons',
            selectedKey: attr.options.filter(opt => opt.isSelected)[0]?.key,
            choices: wranglerOptionsToChoices(attr.options),
            isRequired: allOptionsRequired
        })),
        {
            key: 'Quantity',
            name: uiLabels.quantity,
            style: 'dropdown',
            selectedKey: data.quantities.selected.toString(),
            choices: data.quantities.quantities.map((q, index) => {
                // calculate the total savings for the current quantity relative to the first quantity
                const nonDiscountedPrice = (data.quantities.quantities[0].unitListPrice * q.quantity);
                const discountedPrice = (q.totalDiscountedPrice);
                const savingsTotal = nonDiscountedPrice - discountedPrice;
                const savingsPercent = Math.round((savingsTotal / nonDiscountedPrice) * 100);
                return {
                    key: q.quantity.toString(),
                    name: q.quantity.toString(),
                    isCompatible: true,
                    totalListPrice: q.totalListPrice,
                    totalDiscountedPrice: q.totalDiscountedPrice,
                    unitListPrice: q.unitListPrice,
                    unitDiscountedPrice: q.unitDiscountedPrice,
                    // this is a workaround
                    differentialListPrice: q.totalListPrice,
                    differentialDiscountPrice: q.totalDiscountedPrice,
                    differentialUnitListPrice: q.unitListPrice,
                    differentialUnitDiscountPrice: q.unitDiscountedPrice,
                    savingsPercent: index > 0 ? savingsPercent : 0,
                    savingsTotal: index > 0 ? savingsTotal : 0
                };
            }),
            isRequired: false,
        },
    ];
}
function wranglerOptionsToChoices(options) {
    return options.map((option) => ({
        key: option.key,
        name: option.name,
        description: option.description,
        image: option.images[0],
        callouts: option.badges?.map((b) => ({ key: b.id, text: b.text })),
        isCompatible: option.isCompatible,
        incompatibleReasons: option.incompatibleReasons,
        differentialListPrice: option.differentialListPrice,
        differentialDiscountPrice: option.differentialDiscountPrice,
        differentialUnitListPrice: option.differentialUnitListPrice,
        differentialUnitDiscountPrice: option.differentialUnitDiscountPrice,
    }));
}

export { wranglerAttributeToProductOptionModel };
//# sourceMappingURL=wranglerAttributesToProductOptionModel.mjs.map
